import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "counter", "warning"]
  static values = { max: { type: Number, default: 4 } }

  connect() {
    this.update()
  }

  toggle() {
    this.update()
  }

  update() {
    const checked = this.checkboxTargets.filter(cb => cb.checked)
    const count = checked.length
    const atLimit = count >= this.maxValue

    this.checkboxTargets.forEach(cb => {
      if (!cb.checked) {
        cb.disabled = atLimit
        cb.closest("label")?.classList.toggle("opacity-50", atLimit)
        cb.closest("label")?.classList.toggle("cursor-not-allowed", atLimit)
        cb.closest("label")?.classList.toggle("cursor-pointer", !atLimit)
      }
    })

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${count} / ${this.maxValue} selected`
      this.counterTarget.classList.toggle("text-amber-600", count === this.maxValue)
      this.counterTarget.classList.toggle("font-medium", count === this.maxValue)
    }

    if (this.hasWarningTarget) {
      this.warningTarget.classList.toggle("hidden", count < this.maxValue)
    }
  }
}
